module.exports = __webpack_public_path__ + "static/media/Triviador.51df789d.PNG";